'use strict';

export { default as updateProps } from './updateProps';
//# sourceMappingURL=index.js.map